import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { fetchPaddle, paddlePricesSelector } from './slice';
import { useAppDispatch } from '../configureStore';
import { PaddlePricesResponse } from '../../paddle/models/PaddlePricesResponse';

export const usePaddlePricesState = () => useSelector(paddlePricesSelector);

export const usePaddlePrices: () => PaddlePricesResponse | null = () => {
  const { result, loading } = usePaddlePricesState();
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!result && !loading) {
      dispatch(fetchPaddle()).catch((e) => console.error(e));
    }
  }, [dispatch, result, loading]);
  return result;
};
